import { ThemeColors } from '../../../'

export interface NotificationBannerColors {
  Background: ThemeColors
  CloseIconColor: ThemeColors
  FontColor: ThemeColors
}

export const notificationBannerColors: NotificationBannerColors = {
  Background: {
    default: 'gradients.mangoBrand.new_action_fab_button',
  },
  CloseIconColor: {
    default: 'fg.subtle',
  },
  FontColor: {
    default: 'fg.subtle',
  },
}
